/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {ActionInstance} from "../../../../models/action-instance";
import {InstanceData} from "../../../../models/instance-data";
import {Dialog} from "../../../../models/dialog";
import {Group} from "../../../../models/group";
import {OnInit, Component, Input} from "@angular/core";
import {ActivatedRoute} from "@angular/router";

const PROP_RESPONSE_TIME = "response_time";
const PROP_RESPONSE_UNIT = "response_unit";

@Component({
  selector: 'app-dialog-response-time',
  templateUrl: './dialog-response-time.component.html'
})
export class DialogResponseTimeComponent implements OnInit {
  
  mUnits = Unit;

  @Input()
  set dialog(dialog: Dialog) {
    this.mDialog = dialog;
  }

  @Input()
  mAction: ActionInstance;
    
  //Dialog which is being edited/displayed...
  mDialog: Dialog;
  
  //Response Time value shown in the UI
  mResponseTimeValue: string = null;
  mUnit = Unit.SECONDS;


  constructor(
    
  ) { }

  ngOnInit(): void {
    if (this.mAction != null) {
      const responseTime = this.mAction.data.find(d => d.property.property == PROP_RESPONSE_TIME);  
      this.mResponseTimeValue = responseTime != null ? responseTime.value : null;
        
      const responseUnit = this.mAction.data.find(d => d.property.property == PROP_RESPONSE_UNIT);  
      this.mUnit = responseUnit != null ? Unit[responseUnit.value] : Unit.SECONDS;
    }
  }
  
  onResponseTimeChange(): void {
    console.log("onResponseTimeChange() - Response Time: " + this.mResponseTimeValue);
    if (this.mResponseTimeValue == null || this.mResponseTimeValue.length == 0) {
      this.mDialog.responseTime = null;
      this.removeResponseTime();
    } else {
      const value = Number.parseInt(this.mResponseTimeValue, 10);
      if (Number.isInteger(value)) {
        this.mDialog.responseTime = value;
        this.addResponseTime(this.mResponseTimeValue);
      }
      else {
        this.mDialog.responseTime = null;
      }
    }
    console.log("Setting Response Time to " + this.mDialog.responseTime);
  }

  private addResponseTime(value: string): void {
    //
    // value
    const responseData = this.mAction.data.find(d => d.property.property == PROP_RESPONSE_TIME);
    
    if (responseData == null) {
        const newData = new InstanceData();
        newData.property = this.mAction.action.properties.find(p => p.property == PROP_RESPONSE_TIME);
        newData.value = value;
        this.mAction.data == null ? this.mAction.data = [ newData ] : this.mAction.data.push(newData);
        
        const unitData = new InstanceData();
        unitData.property = this.mAction.action.properties.find(p => p.property == PROP_RESPONSE_UNIT);
        unitData.value = this.mUnit;
        this.mAction.data.push(unitData);
    }
    else {
        responseData.value = value;
        responseData.object_value = value;
    }
  }
    
  private removeResponseTime(): void {
    if (this.mAction == null) {
      return;
    }

    const index = this.mAction.data != null ? this.mAction.data.findIndex(d => d.property.property == PROP_RESPONSE_TIME) : -1;
    
    if (index > -1) {
      this.mAction.data.splice(index, 1);
    }
  }
    
}

enum Unit {
  SECONDS = 'SECONDS',
  MINUTES = 'MINUTES',
  HOURS = 'HOURS',
  DAYS = 'DAYS'
}
